import React from 'react';
import { Paper, Box } from '@mui/material';
import InputFunds from './InputFunds';
import DiscreteSliderLabel from './Slider';
import HighCostThresh from './HighCostThresh';
import Apply from './Apply';
import UnusedSlider from './UnusedSlider';
import FiberType from './FiberTypeSlider';

const styles = {
    paper: {
        padding: '20px',
        width: '402x',
        marginBottom: '16px'
    },
};

/*selectedState={selectedState}
data={data} 

onApplyClick={onApplyClick} 
applyChanges={applyChanges} 
onApplyChange={onApplyChange} 

applyOptimal={applyOptimal} 
onLoadOptimal={onLoadOptimal} 

useOriginalThreshold={useOriginalThreshold}

onCheckboxChange={onCheckboxChange} 
onMatchChange={onMatchChange} 
onUnusedChange={onUnusedChange} 
onStateChange={onStateChange}
onTotalChange={onTotalChange} 
onFiberTypeChange={onFiberTypeChange}

buriedValue={buriedValue}
unusedValue={unusedValue} 
matchValue={matchValue} 

inputTotal={inputTotal}
inputTotalFormat={inputTotalFormat} 

inputThreshold={inputThreshold}
inputThresholdFormat={inputThresholdFormat} 
onThresholdChange={onThresholdChange} 

inputFWSpend={inputFWSpend}
inputFWSpendFormat={inputFWSpendFormat}
onFWSpendChange={onFWSpendChange} 

inputSatSpend={inputSatSpend}
inputSatSpendFormat={inputSatSpendFormat}
onSatSpendChange={onSatSpendChange} */

// Handles the sliders and input fields adjustable by the user
function UserInputComponents({ 

        selectedState,
        data,

        onApplyClick,
        applyChanges,
        onApplyChange,

        applyOptimal,
        onLoadOptimal,

        useOriginalThreshold,

        onCheckboxChange,
        onMatchChange,
        onUnusedChange,
        onStateChange,
        onTotalChange,
        onFiberTypeChange,

        buriedValue,
        unusedValue,
        matchValue,

        inputTotal,
        inputTotalFormat,

        inputThreshold,
        inputThresholdFormat,
        onThresholdChange,

        inputFWSpend,
        inputFWSpendFormat,
        onFWSpendChange,
        
        inputSatSpend,
        inputSatSpendFormat,
        onSatSpendChange,
    }) {
    
    
    /*if(data)
        console.log(unusedValue, data.funds_for_non_deployment, useOriginalThreshold, data.unserved_locations_not_connected.perc, data.underserved_locations_not_connected.perc )

    else
        console.log(unusedValue, '<empty>', useOriginalThreshold)
    */

    // if (data && data.unserved_locations_not_connected.perc === 0.0 && data.underserved_locations_not_connected.perc > 0.0)
    //     if (data.funds_for_non_deployment === 0)
    //         unusedValue = 0


    /*if (data && !useOriginalThreshold && data.funds_for_non_deployment === 0) {
        if (data.funds_for_non_deployment !== unusedValue) {
            unusedValue = data.funds_for_non_deployment
        }
    }*/
    return (
        <div>

            <Paper elevation={8} style={{...styles.paper, paddingBottom: '5px'}} >
                <Box mb={3}>
                    <InputFunds inputTotalFormat={inputTotalFormat} inputTotal={inputTotal} onTotalChange={onTotalChange}/>
                </Box>
                <Box mb={1}>
                    <UnusedSlider unusedValue={unusedValue} onUnusedChange={onUnusedChange} selectedState={selectedState}/>
                </Box>
           
                <Box mb={0}>
                    <DiscreteSliderLabel matchValue={matchValue} onMatchChange={onMatchChange} selectedState={selectedState}/>
                </Box>
                <Box mb={1}>
                    <FiberType buriedValue={buriedValue} onFiberTypeChange={onFiberTypeChange} selectedState={selectedState}/>
                </Box>
            </Paper>

            <Paper elevation={8} style={{...styles.paper, marginBottom: '16px',  paddingBottom: '5px'}}>
                <Box mb={0}>
                    <HighCostThresh  useOriginalThreshold={useOriginalThreshold} onCheckboxChange={onCheckboxChange} inputThreshold={inputThreshold} inputThresholdFormat={inputThresholdFormat} onThresholdChange={onThresholdChange} inputFWSpend={inputFWSpend} inputFWSpendFormat={inputFWSpendFormat}  onFWSpendChange={onFWSpendChange}  inputSatSpend={inputSatSpend} inputSatSpendFormat={inputSatSpendFormat} onSatSpendChange={onSatSpendChange}/>
                </Box>
            </Paper>


            <Paper elevation={8} style={{padding:'14.6px'}}>
                <Box mb={0}>
                    <Apply onApplyClick={onApplyClick} applyChanges={applyChanges}/>
                </Box>
            </Paper>

        </div>
    );
}

export default UserInputComponents;
